const ONBOARDING_SOURCE = 'onboarding'

export { ONBOARDING_SOURCE }
